import { UserContext } from "wrapper/UserWrapper/context";
import { ThemeProvider, useTheme } from "emotion-theming";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { getPlatform } from "../../../helpers";
import { checkSimplEligibility, checkZestEligibility, getSimplRelinkStatus, validateBankOffer } from "store/payment/services";
import { PAYMENT_MODES } from "constants/paymentModes";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { doHandleOtherPaymentClick } from "../common/dependencies/dependencyhelpers";
import { OfferDataInterface } from "wrapper/PaymentWrapper/dependencies/utils/@types/savedMethods";
import { SIMPL_FLOW } from "../common/dependencies/constants";
import { validatePhoneNumber } from "helpers/utils/validatePhoneNumber";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { ValidateBankOfferParams } from "store/payment/@types";
import { doCheckOffers } from "../../../logics/src/utils/checkOffers";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { SpotLoader } from "@nykaa/ui-components/Loader";
import ShopNowPayLaterDesktop from "@nykaa/payment-sdk/src/ShopNowPayLater/desktop";
import ShopNowPayLater from "@nykaa/payment-sdk/src/ShopNowPayLater/mobile";
import RelinkSimplMobile from "@nykaa/payment-sdk/src/RelinkSimpl/mobile";
import RelinkSimplDesktop from "@nykaa/payment-sdk/src/RelinkSimpl/desktop";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { DEVICE_TYPE, TRACKING_EVENTS, BUTTON_TYPE, ACCORDIAN } from "constants/index";


interface IcheckIsSimpleEligibleParams {
  amount: number;
  phone: string;
}

interface IcheckSimplEligibilityResponse {
  success: boolean;
  message: string;
  statusCode: string;
  data: {
    redirectionUrl: null | string;
    message: string;
    statusCode: string;
    reLinkingRequired: string;
  };
}

interface ISimplRelinkStatusResponse {
  success: boolean;
  message: string;
  statusCode: string;
  data: {
    redirectionUrl: null | string;
    message: string;
    statusCode: string;
    reLinkingRequired: boolean;
  };
}

interface IZestEligibilityResponse {
  success: boolean;
  message: string;
  statusCode: string;
  eligible: boolean;
  data: {
    mobileNumber: number;
    reason: string;
    message: string;
  };
}

interface IvalidateBankOfferResponse {
  success: boolean;
  message: string;
  statusCode: string;
  eligibleOffers: string[];
}

const SnplWrapper = ({
  cartRules,
  doPayment,
  isAccordianOpened,
  toggleNewPaymentAccordian,
  newPaymentMethod,
  endIcon,
  isDisabled,
  strikedPaymentText,
  contentRefs,
  accordian,
  newPaymentMethodWithPriority,
}: any) => {
  const paymentContext: any = useContext(PaymentContext);
  const { applicationData } = useContext(ApplicationContext);
  const { userData } = useContext(UserContext);
  const errorModalContext = useContext(ErrorModalContext);
  const cartInfo = paymentContext?.cartInfo;

  const theme = useTheme() as Theme;
  const platform = getPlatform();

  const grandTotal = paymentContext?.orderAmount;
  const paymentInfo = paymentContext?.paymentInfo;
  const isCartRulesLoading = paymentContext?.isCartRulesLoading;
  const setLoading = paymentContext?.setLoading;

  const deviceType = applicationData?.deviceType;
  const isApp = applicationData?.isApp;
  const isGuest = userData?.isGuest;
  const priorityNumber: string = paymentContext?.priorityMobileNumber;
  const openErrorModal = errorModalContext?.openErrorModal;
  const initialOrderAmount = cartInfo?.grandTotal;


  let simplEndIcon: string | (() => SVGElement | JSX.Element) = "";
  let zestEndIcon: string | (() => SVGElement | JSX.Element) = "";

  const [isSimplVisible, setSimplVisible] = useState(false);
  const [isZestVisible, setIsZestVisible] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [inputError, setInputError] = useState("");
  const [isCloseIconVisible, setIsCloseIconVisible] = useState(false);
  const [snplOption, setSnplOption] = useState("");
  /* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
  const [simplRevisedPayNowText, setSimplRevisedPayNowText] = useState("");

  const [isZestMoneyEligible, setIsZestMoneyEligible] = useState(false);
  const [isSimplEligible, setIsSimplEligible] = useState(false);
  /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
  const [simplOffer, setSimplOffer] = useState({} as OfferDataInterface);
  /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
  const [zestOffer, setZestOffer] = useState({} as OfferDataInterface);
  const [simplOfferText, setSimplOfferText] = useState("");
  const [zestMoneyOfferText, setZestOfferText] = useState("");


  const [isSimplLoading, setIsSimplLoading] = useState(false);
  const [simplMessage, setSimplMessage] = useState("");
  const [simplFlow, setSimplFlow] = useState("");
  const [simplRedirectionUrl, setSimplRedirectionUrl] = useState<string | null>(null);
  const [isRelinkBottomSheetVisible, setRelinkBottomSheetVisible] = useState(false);

  const [isZestMoneyLoading, setIsZestMoneyLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [hasMinAmount, setHasMinAmount] = useState(true);
  // to track simpl and zest eligibility has been checked
  const [snplEligibilityChecked, setSNPLEligibilityChecked] = useState(false);

  const [isTyping, setIsTyping] = useState(false);
  let isMessageCardHidden = false;

  const [simplChipColor, setSimplChipColor] = useState({
    chipColor: "",
    chipBackgroundColor: "",
  });

  const [zestChipColor, setZestChipColor] = useState({
    chipColor: "",
    chipBackgroundColor: "",
  });

  /**
   * This is not in use.
   */
  const minAmount = 0;
  const minAmountMessage = "";
  /**
  *
  * @param option can be simpl or zest_money;
  */
  /* eslint-disable no-shadow */
  const toggleSnplOption = (option: string, isDisabled: boolean) => {
    if (!isDisabled) {
      setSnplOption(option);
    }
  };

  /*
  this useEffect gets the focus on the first input field once user opens the accordian
  */

  useEffect(() => {
    let snplInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.SNPL]?.getElementsByClassName("input-element")[0];
    if (snplInputFieldAutoFocus && isAccordianOpened) {
      setTimeout(() => {
        snplInputFieldAutoFocus?.focus({ preventScroll: true });
      }, 20);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isAccordianOpened]);

    /*
    this useEffect gets the focus on the first input field once user opens the accordian in desktop
    */

    useEffect(() => {
      if (deviceType === DEVICE_TYPE.DESKTOP && accordian === PAYMENT_MODES.SNPL) {
          let snplInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.SNPL]?.getElementsByClassName(
              "input-element"
            )[0];
            if (snplInputFieldAutoFocus && isAccordianOpened) {
              setTimeout(() => {
                snplInputFieldAutoFocus?.focus({ preventScroll: true });
              }, 20);
            }
      }
      /* eslint-disable react-hooks/exhaustive-deps */
    }, [accordian]);

  useEffect(() => {
    const doCheckVisibility = (list: string[], mode: string) => {
      if (list?.indexOf(mode) === -1) {
        return false;
      }
      return true;
    };
    /**
     * simpl is visible if newPaymentMethod includes simpl
     * zest is visible if newPaymentMethod includes zest_money
     * bnpl option is not present for guest user
     */
    if (isGuest) {
      setSimplVisible(false);
      setIsZestVisible(false);
    } else {
      const isSimplAvailable = doCheckVisibility(newPaymentMethod, PAYMENT_MODES.SIMPL);
      const isZestAvailable = doCheckVisibility(newPaymentMethod, PAYMENT_MODES.ZEST_MONEY);

      setSimplVisible(isSimplAvailable);
      setIsZestVisible(isZestAvailable);
    }
  }, [isGuest, newPaymentMethod]);

  useEffect(() => {
    if (isSimplEligible) {
      toggleSnplOption(PAYMENT_MODES.SIMPL, !isSimplEligible);
    } else if (isZestMoneyEligible) {
      toggleSnplOption(PAYMENT_MODES.ZEST_MONEY, !isZestMoneyEligible);
    }
    // apps tracking for snpl eligibility
    if (snplEligibilityChecked) {
      allTrackingHandlerForApps({
        event: TRACKING_EVENTS.SNPL_ELIGIBILITY_CHECKED,
        isSimplEligible,
        isZestMoneyEligible,
        isApp,
      });
    }
  }, [isSimplEligible, isZestMoneyEligible]);

  useMemo(() => {
    if (priorityNumber) {
      setPhoneNumber(priorityNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priorityNumber]);


  /**
   * Simpl Payment Method Logic starts
   */

  /**
   * @description checkIsSimpleEligible function calls eligibility api for simpl payment
   * @param amount amout to pay
   * @param phone user phone number
   */

  const checkIsSimpleEligible = async ({ amount, phone }: IcheckIsSimpleEligibleParams) => {
    checkSimplEligibility({ amount, phone, deviceType })
      .then(
        (response: IcheckSimplEligibilityResponse) => {
          if (response?.success && response?.data) {
            const message = response?.data?.message;
            const statusCode = response?.data?.statusCode;
            const url = response?.data?.redirectionUrl;

            setSimplMessage(message);
            setSimplFlow(statusCode);

            switch (statusCode) {
              case SIMPL_FLOW.ELIGIBLE:
                setIsSimplEligible(true);
                break;
              case SIMPL_FLOW.LINK_AND_PAY:
                setIsSimplEligible(true);
                setSimplRedirectionUrl(url);
                break;
              case SIMPL_FLOW.RELINK_AND_PAY:
                setIsSimplEligible(true);
                break;
              default:
                setIsSimplEligible(false);
                break;
            }
          } else {
            const statusCode = response?.statusCode;
            const message = response?.message;
            setIsSimplEligible(false);
            setSimplFlow(statusCode);
            setSimplMessage(message);
          }
          setIsSimplLoading(false);
          setSNPLEligibilityChecked(true);
        }
      )
      .catch(() => {
        setIsSimplLoading(false);
      });
  };

  const checkIsSimplRelinked = () => {
    const params = {
      amount: simplOffer?.finalOrderAmount || grandTotal,
      phone: phoneNumber,
      deviceType,
    };
    getSimplRelinkStatus(params)
      .then(
        (response: ISimplRelinkStatusResponse) => {
          if (response?.success && response?.data) {
            const message = response?.data?.message;
            const statusCode = response?.data?.statusCode;
            const url = response?.data?.redirectionUrl;
            setSimplMessage(message);
            setSimplFlow(statusCode);
            setSimplRedirectionUrl(url);
            if (statusCode == SIMPL_FLOW.LINK_AND_PAY) {
              doPayment(PAYMENT_MODES.SIMPL, {
                phone: phoneNumber,
                simplFlow: statusCode,
                simplRedirectionUrl: url,
                grandTotal: simplOffer?.finalOrderAmount || grandTotal,
                mode: PAYMENT_MODES.SIMPL,
                offerData: simplOffer,
              });
            }
          } else {
            const statusCode = response?.statusCode;
            const message = response?.message;
            if (statusCode == SIMPL_FLOW.ALREADY_LINKED) {
              setIsSimplEligible(false);
              setSimplMessage(message);
            }
          }

          setRelinkBottomSheetVisible(false);
          setIsSimplLoading(false);
        }
      )
      .catch(() => {
        setIsSimplLoading(false);
        openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, "");
      });
  };

  const onRelinkAndPayBottomSheetSuccess = () => {
    checkIsSimplRelinked();
  };

  const onRelinkAndPayBottomSheetDismiss = () => {
    setRelinkBottomSheetVisible(false);
  };

  const doPaymentSimpl = () => {
    const { error: phoneError, hasError } = validatePhoneNumber(phoneNumber || "");
    setInputError(phoneError);
    setLoading(true);
    if (!hasError) {
      if (simplFlow === SIMPL_FLOW.ELIGIBLE) {
        doPayment(PAYMENT_MODES.SIMPL, {
          phone: phoneNumber,
          simplFlow,
          mode: PAYMENT_MODES.SIMPL,
          offerData: simplOffer,
        });
      } else if (simplFlow === SIMPL_FLOW.LINK_AND_PAY) {
        doPayment(PAYMENT_MODES.SIMPL, {
          phone: phoneNumber,
          simplFlow,
          simplRedirectionUrl,
          grandTotal: simplOffer?.finalOrderAmount || grandTotal,
          mode: PAYMENT_MODES.SIMPL,
          offerData: simplOffer,
        });
      } else if (simplFlow === SIMPL_FLOW.RELINK_AND_PAY) {
        setRelinkBottomSheetVisible(true);
        setLoading(false);
      }
    }
  };

  /**
   * Simpl Payment Method Logic ends
   */

  /**
   * Zest Payment Method Logic starts
   */

  // function for checking zest money eligibility
  const checkIsZestEligibile = (amount: number, phone: string) => {
    if (isZestVisible) {
      checkZestEligibility({ amount, phone })
        .then((response: IZestEligibilityResponse) => {
          setIsZestMoneyEligible(response && response?.eligible);
          setReason(response.message);
          setSNPLEligibilityChecked(true);
          setIsZestMoneyLoading(false);
        }
        )
        .catch(() => {
          setIsZestMoneyLoading(false);
        });
    } else {
      setIsZestMoneyLoading(false);
    }
  };

  const clearPhoneNumberInput = () => {
    setPhoneNumber("");
    setInputError("");
    setIsSimplEligible(false);
    setIsZestMoneyEligible(false);
    setSimplMessage("");
    setReason("");
    toggleSnplOption("", false);
  };

  useMemo(() => {
    if (grandTotal < minAmount) {
      setHasMinAmount(false);
      setIsZestMoneyEligible(false);
      setReason(minAmountMessage);
      setTimeout(() => {
        setIsZestMoneyLoading(false);
      }, 500);
    } else if (!hasMinAmount) {
      setHasMinAmount(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    grandTotal,
    minAmount,
    hasMinAmount,
    reason,
    phoneNumber,
    minAmountMessage,
    isZestMoneyLoading,
  ]);

  const validateZestOffer = () => {
    let zestMoneyOffers = cartRules?.paymentRules?.filter(
      (rule: PaymentOfferRule) =>
        rule.paymentMethod === PAYMENT_MODES.ZEST_MONEY
    );
    // sort based on priority
    if (zestMoneyOffers?.length > 1) {
      zestMoneyOffers = zestMoneyOffers.sort(
        (a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority
      );
    }
    if (zestMoneyOffers?.length) {
      const offerData = zestMoneyOffers[0];
      if (offerData && offerData?.ruleKey) {
        const validateBankOfferParams: ValidateBankOfferParams = {
          deviceType,
          mode: PAYMENT_MODES.ZEST_MONEY.toUpperCase(),
          offerKeyList: [offerData?.ruleKey],
          paymentInstrumentDTO: {
            phoneNo: phoneNumber,
          },
        };

        validateBankOffer(validateBankOfferParams).then(
          (response: IvalidateBankOfferResponse) => {
            if (response) {
              const offer: OfferDataInterface = doCheckOffers(
                false,
                PAYMENT_MODES.ZEST_MONEY,
                cartRules,
                paymentInfo,
                response?.eligibleOffers
              );
              if (offer?.hasOffers) {
                setZestOffer(offer);
                const offerText = offer?.genericDiscountMsg?.toUpperCase() as string;
                setZestOfferText(offerText);

                if (zestEndIcon === getIcons(platform, ICONS_NAMES.RADIO)) {
                  const chipColor = getChip("success");
                  setZestChipColor(chipColor);
                } else {
                  const chipColor = getChip();
                  setZestChipColor(chipColor);
                }
              }

              checkIsZestEligibile(
                offer?.finalOrderAmount || grandTotal,
                phoneNumber
              );
            }
          }
        );
      }
    } else {
      checkIsZestEligibile(
        zestOffer?.finalOrderAmount || grandTotal,
        phoneNumber
      );
    }
  };

  /**
   * Zest Payment Method Logic ends
  */

  /**
   * Common logic for Zest and Simpl ends
   */

  useMemo(() => {
    // isAccordianOpened
    if (grandTotal && phoneNumber && !inputError && !isCartRulesLoading && isAccordianOpened) {
      setIsSimplLoading(true);
      setIsZestMoneyLoading(true);

      if (isSimplVisible) {
        let simplOffers = cartRules?.paymentRules?.filter(
          (rule: PaymentOfferRule) =>
            rule.paymentMethod === PAYMENT_MODES.SIMPL
        );
        // sort based on priority
        if (simplOffers?.length > 1) {
          simplOffers = simplOffers.sort(
            (a: PaymentOfferRule, b: PaymentOfferRule) =>
              b?.priority - a?.priority
          );
        }

        if (simplOffers?.length) {
          const offerData = simplOffers[0];
          if (offerData && offerData?.ruleKey) {
            const validateBankOfferParams: ValidateBankOfferParams = {
              deviceType,
              mode: PAYMENT_MODES.SIMPL.toUpperCase(),
              offerKeyList: [offerData?.ruleKey],
              paymentInstrumentDTO: {
                phoneNo: phoneNumber,
              },
            };

            validateBankOffer(validateBankOfferParams).then(
              (response: IvalidateBankOfferResponse) => {
                if (response) {
                  const offer: OfferDataInterface = doCheckOffers(
                    false,
                    PAYMENT_MODES.SIMPL,
                    cartRules,
                    paymentInfo,
                    response?.eligibleOffers
                  );

                  if (offer?.hasOffers) {
                    setSimplOffer(offer);
                    const offerText = offer?.genericDiscountMsg?.toUpperCase() as string;
                    setSimplOfferText(offerText);

                    if (simplEndIcon === getIcons(platform, ICONS_NAMES.RADIO_ACTIVE)) {
                      const chipColor = getChip("success");
                      setSimplChipColor(chipColor);
                    } else {
                      const chipColor = getChip();
                      setSimplChipColor(chipColor);
                    }
                  }

                  checkIsSimpleEligible({
                    amount: offer?.finalOrderAmount || grandTotal,
                    phone: phoneNumber,
                  });
                }
              }
            );
          }
        } else {
          checkIsSimpleEligible({
            amount: simplOffer?.finalOrderAmount || grandTotal,
            phone: phoneNumber,
          });
        }
      } else {
        setIsSimplLoading(false);
        setIsZestMoneyLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // isAccordianOpened
  }, [phoneNumber, isSimplVisible, isCartRulesLoading, isAccordianOpened]);


  useMemo(() => {
    // isAccordianOpened
    if (!(grandTotal && phoneNumber && !inputError && !isCartRulesLoading && isAccordianOpened))
      return;

    if (hasMinAmount) {
      validateZestOffer();
    } else {
      setIsZestMoneyLoading(false);
    }
    // isAccordianOpened
  }, [phoneNumber, isCartRulesLoading, isAccordianOpened]);


  const handleInputChange = (value: string) => {
    if (value || value == "") {
      value = value.replace(/[^0-9 ]/g, "");
      if (value.length <= 10) {
        const phoneStatus = validatePhoneNumber(value);
        setPhoneNumber(value);
        setInputError(phoneStatus?.error);
        setIsTyping(true);
        setSimplMessage("");
        setIsSimplEligible(false);
        setIsZestMoneyEligible(false);
        setReason("");
        isMessageCardHidden = true;
        if (value.length === 10) {
          setIsTyping(false);
        }
        toggleSnplOption("", false);
      }
    }
  };


  const getChip = (type?: string) => {
    let chipConfig = {
      chipColor: "",
      chipBackgroundColor: "",
    };
    if (type === "success") {
      chipConfig = {
        chipColor: theme?.colors?.positive,
        chipBackgroundColor: theme?.colors?.positive50,
      };
    } else {
      chipConfig = {
        chipColor: theme?.colors?.info,
        chipBackgroundColor: theme?.colors?.info50,
      };
    }
    return chipConfig;
  };

  const handleZestSubmitClick = () => {
    if (isZestMoneyEligible) {
      setLoading(true);
      doPayment(PAYMENT_MODES.ZEST_MONEY, {
        phone: phoneNumber,
        mode: PAYMENT_MODES.ZEST_MONEY,
        offerData: zestOffer,
      });
    } else {
      if (hasMinAmount && phoneNumber && !inputError) {
        let amount = grandTotal;
        checkIsZestEligibile(amount, phoneNumber);
      }
    }
  };


  let payNowText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_PAY,
    `Pay ₹${grandTotal}`,
    { count: grandTotal }
  );


  let linkAndPay = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY,
    `Link & Pay ₹${grandTotal}`,
    { count: grandTotal }
  );


  let relinkAndPay = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_RELINK_AND_PAY,
    `Relink & Pay ₹${grandTotal}`,
    { count: grandTotal }
  );


  let simplButtonText = useRef(payNowText);
  let simplRevisedButtonText = useRef(simplRevisedPayNowText);

  useMemo(() => {
    switch (simplFlow) {
      case SIMPL_FLOW.LINK_AND_PAY:
        simplButtonText.current = linkAndPay;

        if (simplOffer?.hasOffers) {
          simplRevisedButtonText.current = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Link & Pay &nbsp; ₹${simplOffer?.finalOrderAmount} &nbsp; <del>₹${initialOrderAmount}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffer?.finalOrderAmount || "",
            }
          );
        } else if (strikedPaymentText) {
          simplRevisedButtonText.current = `Link & ${strikedPaymentText}`;
        } else {
          simplRevisedButtonText.current = linkAndPay;
        }

        break;
      case SIMPL_FLOW.RELINK_AND_PAY:
        simplButtonText.current = relinkAndPay;

        if (simplOffer?.hasOffers) {
          simplRevisedButtonText.current = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Relink & Pay &nbsp; ₹${simplOffer?.finalOrderAmount} &nbsp; <del>₹${initialOrderAmount}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffer?.finalOrderAmount || "",
            }
          );
        } else if (strikedPaymentText) {
          simplRevisedButtonText.current = `Relink & ${strikedPaymentText}`;
        } else {
          simplRevisedButtonText.current = relinkAndPay;
        }

        break;
      default:
        simplButtonText.current = payNowText;
        if (simplOffer?.hasOffers) {
          simplRevisedButtonText.current = getStringFromId(
            VERNACULAR_STRING_IDS.DYNAMIC_LINK_AND_PAY_WITH_STRIKED_AMOUNT,
            `Pay &nbsp; ₹${simplOffer?.finalOrderAmount} &nbsp; <del>₹${initialOrderAmount}</del>`,
            {
              oldAmount: initialOrderAmount,
              newAmount: simplOffer?.finalOrderAmount,
            }
          );
        } else if (strikedPaymentText) {
          simplRevisedButtonText.current = strikedPaymentText;
        } else {
          simplRevisedButtonText.current = payNowText;
        }
    }
  }, [simplFlow, grandTotal, simplOffer]);

  let title = getStringFromId(
    VERNACULAR_STRING_IDS.SHOP_NOW_PAY_LATER_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.SHOP_NOW_PAY_LATER_TITLE
  );
  if (deviceType === DEVICE_TYPE.DESKTOP) {
    title = getStringFromId(
      VERNACULAR_STRING_IDS.SHOP_NOW_PAY_LATER_TITLE_DESKTOP,
      VERNACULAR_DEFAULT_MESSAGES.SHOP_NOW_PAY_LATER_TITLE_DESKTOP
    );
  }
  const subTitle = getStringFromId(
    VERNACULAR_STRING_IDS.SHOP_NOW_PAY_LATER_SUBTITLE,
    VERNACULAR_DEFAULT_MESSAGES.SHOP_NOW_PAY_LATER_SUBTITLE
  );
  const simplTitle = getStringFromId(
    VERNACULAR_STRING_IDS.SIMPL_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.SIMPL_TITLE
  );
  const phoneNumberLabelText = getStringFromId(
    VERNACULAR_STRING_IDS.PHONE_NUMBER,
    VERNACULAR_DEFAULT_MESSAGES.PHONE_NUMBER
  );
  const zestMoneyTitle = getStringFromId(
    VERNACULAR_STRING_IDS.ZEST_MONEY_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.ZEST_MONEY_TITLE
  );
  const relinkAndPayBottomSheetTitle = getStringFromId(
    VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_TITLE
  );
  const relinkAndPayBottomSheetSubTitle = getStringFromId(
    VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_SUBTITLE,
    VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_SUBTITLE
  );
  const relinkSuccessButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_SUCCESS_BUTTON_TEXT,
    VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_SUCCESS_BUTTON_TEXT
  );
  const relinkDismissButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.RELINK_BOTTOM_SHEET_DISMISS_BUTTON_TEXT,
    VERNACULAR_DEFAULT_MESSAGES.RELINK_BOTTOM_SHEET_DISMISS_BUTTON_TEXT
  );

  let revisedPayNowTextForZest = strikedPaymentText;
  if (zestOffer?.hasOffers) {
    revisedPayNowTextForZest = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
      `Pay ₹${zestOffer?.finalOrderAmount} &nbsp; <del>₹${initialOrderAmount}</del>`,
      { oldAmount: initialOrderAmount, newAmount: zestOffer?.finalOrderAmount || "" }
    );
  }

  let messageCardText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_PAY_SHOP_NOW_PAY_LATER,
    `You can pay ₹${grandTotal} from other payment options`,
    { count: grandTotal }
  );

  if (isSimplLoading) {
    simplEndIcon = () => (<ThemeProvider theme={theme}> <SpotLoader /> </ThemeProvider>);
  } else if (isSimplEligible && snplOption === PAYMENT_MODES.SIMPL) {
    simplEndIcon = getIcons(platform, ICONS_NAMES.RADIO_ACTIVE);
  } else if (isTyping && !isSimplEligible) {
    simplEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!phoneNumber && !isSimplEligible) {
    simplEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!phoneNumber && isSimplEligible) {
    simplEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!isSimplEligible) {
    simplEndIcon = getIcons(platform, ICONS_NAMES.ALERT_SIMPL);
  } else {
    simplEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  }

  if (isZestMoneyLoading) {
    zestEndIcon = () => (<ThemeProvider theme={theme}> <SpotLoader /></ThemeProvider>);
  } else if (isZestMoneyEligible && snplOption === PAYMENT_MODES.ZEST_MONEY) {
    zestEndIcon =
      getIcons(platform, ICONS_NAMES.RADIO_ACTIVE);
  } else if (isTyping && !isZestMoneyEligible) {
    zestEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!phoneNumber && !isZestMoneyEligible) {
    zestEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!phoneNumber && isZestMoneyEligible) {
    zestEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  } else if (!isZestMoneyEligible) {
    zestEndIcon = getIcons(platform, ICONS_NAMES.ALERT_SIMPL);
  } else if (grandTotal < minAmount) {
    zestEndIcon = getIcons(platform, ICONS_NAMES.ALERT_SIMPL);
  } else {
    zestEndIcon = getIcons(platform, ICONS_NAMES.RADIO);
  }

  /**
   * this function is to switch to the first new payment method
   * if user is not eligible for any method
   * if cod on first place then show second
   * payment option to user.
   */
  const doPaymentWithOtherMethod = () => {
    doHandleOtherPaymentClick({
      deviceType,
      paymentMethodDesktop: newPaymentMethod,
      paymentMethodMsite: newPaymentMethodWithPriority,
      callBackForDesktop: toggleNewPaymentAccordian,
      callBackForMsite: toggleNewPaymentAccordian,
      currentPaymentOption: ACCORDIAN.SNPL,
    });
    return;
  };

  if (!isSimplEligible && !isZestMoneyEligible && !isTyping && phoneNumber) {
    isMessageCardHidden = false;
  } else {
    isMessageCardHidden = true;
  }

  let simplSubTitleColor = "";
  if (simplButtonText.current === relinkAndPay) {
    simplSubTitleColor = theme.colors.notificationWarningFill;
  } else if (!isSimplEligible) {
    simplSubTitleColor = theme.colors.negative;
  } else if (isSimplEligible) {
    simplSubTitleColor = theme.colors.notificationPositiveText;
  }

  let zestSubTitleColor;
  if (isZestMoneyEligible) {
    zestSubTitleColor = theme.colors.notificationPositiveText;
  } else if (!isZestMoneyEligible) {
    zestSubTitleColor = theme.colors.negative;
  }
  const simplLoadingText = getStringFromId(
    VERNACULAR_STRING_IDS.PLEASE_WAIT_WHILE,
    VERNACULAR_DEFAULT_MESSAGES.PLEASE_WAIT_WHILE
  );

  let text;
  if (isSimplLoading) {
    text = {
      text: simplLoadingText,
      info: true,
      leadingIcon: "",
      success: "",
    };
  } else if (isSimplEligible) {
    text = {
      text: simplMessage,
      info: true,
      leadingIcon: getIcons(platform, ICONS_NAMES.SUCCESS_ICON),
      success: true,
    };
  } else if (!isSimplLoading && !isSimplEligible) {
    text = {
      text: simplMessage,
      info: true,
      leadingIcon: getIcons(platform, ICONS_NAMES.ALERT),
      warn: true,
    };
  } else {
    text = {
      text: "",
      info: true,
      leadingIcon: "",
      success: "",
    };
  }


  const onInputBlur = () => {
    setIsCloseIconVisible(false);
    setIsTyping(false);
  };


  /**
   * this is for showing simpl and zest payment method on All payment screen
   */
  const config = {
    isAccordianOpened,
    toggleAccordian: () => toggleNewPaymentAccordian("snpl", isDisabled),
    isDisabled,
    title,
    subTitle,
    phoneNumberLabelText,
    phoneNumber,
    inputIcon: getIcons(platform, ICONS_NAMES.CLEAR),
    onInputIconClick: clearPhoneNumberInput,
    isInputIconVisible: isCloseIconVisible,
    errorText: inputError,
    onChange: handleInputChange,
    onFocus: () => {
      setIsCloseIconVisible(true);
    },
    onBlur: onInputBlur,
    leadingIcon: getIcons(platform, ICONS_NAMES.SNPL),
    endIcon,
    isHidden: !isSimplVisible && !isZestVisible,
    payLaterConfig: [
      {
        title: simplTitle,
        subTitle: simplMessage,
        subTitleColor: simplSubTitleColor,
        isAccordianOpened: isSimplEligible && snplOption === PAYMENT_MODES.SIMPL,
        offerText: simplOfferText,
        payNowText: simplButtonText?.current,
        revisedPayNowText: simplRevisedButtonText?.current,
        leadingIcon: getIcons(platform, ICONS_NAMES.SIMPL),
        endIcon: simplEndIcon,
        toggleAccordian: () => toggleSnplOption(PAYMENT_MODES.SIMPL, !isSimplEligible),
        doPayment: doPaymentSimpl,
        isSubmitButtonDisabled: !isSimplEligible,
        isDisabled: !isSimplEligible,
        isHidden: !isSimplVisible,
        chipColor: simplChipColor,
        buttonType: BUTTON_TYPE.MEDIUM,
      },
      {
        title: zestMoneyTitle,
        subTitle: reason,
        subTitleColor: zestSubTitleColor,
        isAccordianOpened: isZestMoneyEligible && snplOption === PAYMENT_MODES.ZEST_MONEY,
        offerText: zestMoneyOfferText,
        payNowText,
        revisedPayNowText: revisedPayNowTextForZest,
        leadingIcon: getIcons(platform, ICONS_NAMES.SAVED_ZEST_MONEY),
        endIcon: zestEndIcon,
        toggleAccordian: () => toggleSnplOption(PAYMENT_MODES.ZEST_MONEY, !isZestMoneyEligible),
        doPayment: isZestMoneyEligible && handleZestSubmitClick,
        isSubmitButtonDisabled: !isZestMoneyEligible,
        isDisabled: !isZestMoneyEligible,
        isHidden: !isZestVisible,
        chipColor: zestChipColor,
        buttonType: BUTTON_TYPE.MEDIUM,
      },
    ],
    messageConfig: {
      message: {
        text: messageCardText,
        info: true,
      },
      actionButtonText: "Proceed with other payments",
      actionButtonEndIcon: getIcons(platform, ICONS_NAMES.ACTION_ICON),
      isHidden: isMessageCardHidden,
      onButtonClick: doPaymentWithOtherMethod,
      theme: theme,
    },
    relinkBottomSheetConfig: { // for desktop
      icon: getIcons(platform, ICONS_NAMES.CLEAR),
      maxHeight: 85,
      theme: theme,
      title: relinkAndPayBottomSheetTitle,
      subTitle: relinkAndPayBottomSheetSubTitle,
      successButtonText: relinkSuccessButtonText,
      dismissButtontext: relinkDismissButtonText,
      isVisible: isRelinkBottomSheetVisible,
      onSuccess: onRelinkAndPayBottomSheetSuccess,
      onDismiss: onRelinkAndPayBottomSheetDismiss,
    },
    isBankOfferApplied: ((simplOfferText || zestMoneyOfferText) && (isSimplEligible || isZestMoneyEligible)) ? true : false,
    theme,
  };

  /** for mobile */
  const relinkBottomSheetConfig = {
    icon: getIcons(platform, ICONS_NAMES.CLEAR),
    maxHeight: 85,
    theme: theme,
    title: relinkAndPayBottomSheetTitle,
    subTitle: relinkAndPayBottomSheetSubTitle,
    successButtonText: relinkSuccessButtonText,
    dismissButtontext: relinkDismissButtonText,
    isVisible: isRelinkBottomSheetVisible,
    onSuccess: onRelinkAndPayBottomSheetSuccess,
    onDismiss: onRelinkAndPayBottomSheetDismiss,
  };

  if (deviceType === DEVICE_TYPE.DESKTOP) {
    return <>
      <ShopNowPayLaterDesktop {...config} />
      <RelinkSimplDesktop
        isVisible={relinkBottomSheetConfig?.isVisible}
        text={relinkBottomSheetConfig?.subTitle}
        successButtonText={relinkBottomSheetConfig?.successButtonText}
        dismissButtonText={relinkBottomSheetConfig?.dismissButtontext}
        onSuccess={relinkBottomSheetConfig?.onSuccess}
        onDismiss={relinkBottomSheetConfig?.onDismiss}
        relinkTitle={relinkBottomSheetConfig?.title}
        theme={theme}
      />
    </>;
  }

  return (
    <>
      <ShopNowPayLater {...config} />
      <RelinkSimplMobile
        isBottomSheetVisible={relinkBottomSheetConfig?.isVisible}
        text={relinkBottomSheetConfig?.subTitle}
        successButtonText={relinkBottomSheetConfig?.successButtonText}
        dismissButtonText={relinkBottomSheetConfig?.dismissButtontext}
        onSuccess={relinkBottomSheetConfig?.onSuccess}
        onDismiss={relinkBottomSheetConfig?.onDismiss}
        relinkTitle={relinkBottomSheetConfig?.title}
        theme={theme}
      />
    </>
  );
};

export default SnplWrapper;
